import React, { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import PublicNav from "./PublicNav";
import Footer from "./Footer";

const SettingsContext = createContext({});
export const useSettings = () => useContext(SettingsContext);

const PublicLayout = ({ children }) => {
  const { data: settings } = useQuery({
    queryKey: ["settings"],
    queryFn: async () => (await api.get("/settings")).data,
  });
  return (
    <SettingsContext.Provider value={settings || {}}>
      <div className="min-h-screen flex flex-col bg-white">
        <PublicNav />
        <main className="flex-1">{children}</main>
        <Footer settings={settings} />
      </div>
    </SettingsContext.Provider>
  );
};

export default PublicLayout;
